class TipoRequisicaoCompraEnum {
    constructor(cod, desc) {
      this.cod = cod;
      this.desc = desc;
    }
  
    static fromcod(cod) {
      return Object.values(TipoRequisicaoCompraEnum).find(status => status.cod === cod);
    }
  
    static fromDesc(desc) {
      return Object.values(TipoRequisicaoCompraEnum).find(status => status.desc === desc);
    }
  }
  
  TipoRequisicaoCompraEnum.COMPRA_DIRETA = new TipoRequisicaoCompraEnum(1, "Compra Direta");
  TipoRequisicaoCompraEnum.LICITACAO = new TipoRequisicaoCompraEnum(2, "Licitação (Pregão, Concorrência, etc.)");
  TipoRequisicaoCompraEnum.ADESAO_ATA_REGISTRO_PRECO = new TipoRequisicaoCompraEnum(3, "Adesão a Ata de Registro de Preços (ARP)");
  TipoRequisicaoCompraEnum.SUPRIMENTO_FUNDO = new TipoRequisicaoCompraEnum(4, "Suprimento de Fundos");
  TipoRequisicaoCompraEnum.INEXIGIBILIDADE = new TipoRequisicaoCompraEnum(5, "Inexigibilidade");
  TipoRequisicaoCompraEnum.DISPENSA_POR_VALOR = new TipoRequisicaoCompraEnum(6, "Dispensa por valor");
  TipoRequisicaoCompraEnum.DISPENSA_POR_EMERGÊNCIA = new TipoRequisicaoCompraEnum(7, "Dispensa por emergência");
  TipoRequisicaoCompraEnum.REGISTRO_PRECO = new TipoRequisicaoCompraEnum(7, "REGISTRO_PRECO");


  export default TipoRequisicaoCompraEnum;